import { useMemo } from 'react'
import { AccountHomeTaskMapKey } from '../AccountHomeLink/AccountHomeLink'

const MAX_ITEMS = 3

export type PersonalizedNavItem = {
  id: AccountHomeTaskMapKey,
  hideDesktop: boolean,
  hideMobile: boolean,
}

const responsiveMap: { [K in AccountHomeTaskMapKey]?: { hideDesktop?: boolean, hideMobile?: boolean } } = {
  editAccountSettings: {
    hideMobile: true
  }
}

function determineDisplay (id: AccountHomeTaskMapKey): PersonalizedNavItem {
  return ({
    id,
    hideDesktop: false,
    hideMobile: false,
    ...(responsiveMap[id] || {})
  })
}

type usePersonalizedNavArgs = {
  isMedicareAdvantage?: boolean
  isImmunosuppressiveDrugCoverage?: boolean
  isEMsnEnrolled?: boolean
}
export function usePersonalizedNav (args: usePersonalizedNavArgs) {
  const {
    isMedicareAdvantage,
    isImmunosuppressiveDrugCoverage,
    isEMsnEnrolled
  } = args

  const items = useMemo(() => {
    const personalizedList = [
      ...(!isMedicareAdvantage ? ['checkClaims'] : []),
      ...(!isMedicareAdvantage
        ? isEMsnEnrolled
          ? ['getEmsns']
          : ['getEmsns2']
        : []),
      'getMedicareCard',
      'checkProviders',
      ...(!isMedicareAdvantage && !isImmunosuppressiveDrugCoverage
        ? ['checkPreventiveServices']
        : []),
      'updatePharmacies',
      'updateDrugs'
    ].slice(0, MAX_ITEMS) as AccountHomeTaskMapKey[]

    // Add extra values to determine responsive display
    return personalizedList.map(determineDisplay)
  }, [isMedicareAdvantage, isImmunosuppressiveDrugCoverage, isEMsnEnrolled])

  const alwaysShown: AccountHomeTaskMapKey[] = [
    'payPremium',
    'editAccountSettings',
    'allOptions'
  ]
  const extraItems = alwaysShown.map(determineDisplay)

  return { items, extraItems }
}
